export default "__VITE_ASSET__b2af783d__"